import { Api } from "@/shared/services/api";
import axios, {AxiosRequestConfig} from "axios";

export class ApiDocument extends Api {

    public getConfigApi(): AxiosRequestConfig {
        return super.getConfigApi();
    }

    public getUrl(id:string): string {
//        return "http://localhost:8080/iw-web/pdf-file/66fdf53a41ed43f9b99d5f508cfc323c.pdf"
        return  new URL(axios.getUri(super.getConfigApi()) + "/pdf-file/" + id, window.location.origin).toString();
        //'localhost:8080'+axios.getUri(super.getConfigApi()) + "/pdf-file/" + id;
    }

    public async getFileData(id: string): Promise<Uint8Array> {
        const resp = await axios.get("/pdf-file/" + id, {
            ...this.getConfigApi(),
            responseType: "arraybuffer",
        });
        return new Uint8Array(resp.data);
    }

    public getSettings() {
        console.log(axios.getUri(super.getConfigApi()));
        return {
            ajaxHeaders: [
                {
                    headerName: 'Authorization',
                    headerValue: "Bearer " + Api.token
                }
            ],
            withCredentials: false
        }
    }

}

const apiDocument = new ApiDocument();

export default apiDocument;

